import styled from "styled-components";

export const InquirySearchResultsStyle = styled.div`
    padding: 25px;
    overflow: scroll;
`;
